<template>
  <label
    class="simple__radio-label_container">
    <input
      :checked="checked"
      :value="text"
      type="radio"
      class="simple__radio-input radio-input"
    >
    <span
      v-if="text"
      class="simple__radio-label choice">
      <span
        class="simple__radio-choice choice"
        v-text="text"
      />
    </span>
  </label>
</template>
<script>
  export default {
    name: 'ChoiceSimple',
    props: {
      text: {
        type: String,
        required: true,
      },
      image: {
        type: String,
        default: null,
      },
      checked: {
        type: Boolean,
        required: true,
      },
    },
  };
</script>
<style lang="scss">
.simple__radio-label_container {
    position: relative;
}

.simple__radio-label {
    position: relative;
    display: inline-block;
    cursor: pointer;
    background: none;
    border: 0;
    border-radius: 0;
    appearance: none;
    outline: 0;
    transition: color $radio-simple-transition-duration $radio-simple-transition-easing;

    &:hover,
    &:focus {

      @include breakpoint(large) {
        &::after {
            transition:
              background $radio-simple-transition-duration $radio-simple-transition-easing,
              border $radio-simple-transition-duration $radio-simple-transition-easing;
            //transform: scale(0.3);
            background: $gray;
            border: $radio-border-size solid $gray;
        }
      }
    }

    &::before {
        position: absolute;
        top: 2px;
        left: 0;
        display: inline-block;
        width: $radio-simple-size;
        height: $radio-simple-size;
        content: "";
        border: $radio-border-size solid $gray;
        border-radius: $radio-border-radius;
    }

    &::after {
        position: absolute;
        top: 2px + $radio-border-size;
        left: $radio-border-size;
        display: inline-block;
        width: $radio-simple-size - ($radio-border-size * 2);
        height: $radio-simple-size - ($radio-border-size * 2);
        content: "";
        border-color: $gray;
        transform: scale(0.6);
        transition:
          background $radio-simple-transition-duration $radio-simple-transition-easing,
          border $radio-simple-transition-duration $radio-simple-transition-easing;
        border-radius: $radio-border-radius;
    }
}

.simple__radio-choice {
  display: inline-block;
  margin-left: $radio-simple-size + 10px;
}

.simple__radio-input:checked + .simple__radio-label {
    &::after {
        transition:
          background $radio-simple-transition-duration $radio-simple-transition-easing,
          border $radio-simple-transition-duration $radio-simple-transition-easing ;
        //transform: scale(0.6);
        background: $turquoise;
        border: $radio-border-size solid $turquoise;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ChoiceSimple.vue